import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { validateEnv } from './config/env';

// FontAwesome setup
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebookF, faInstagram, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';

// Validate environment variables before app starts
try {
  validateEnv();
} catch (error) {
  console.error('Environment validation failed:', error);
  // In production, you might want to show a user-friendly error page
  if (process.env.NODE_ENV === 'production') {
    document.body.innerHTML = `
      <div style="display: flex; align-items: center; justify-content: center; height: 100vh; font-family: sans-serif; text-align: center; padding: 2rem;">
        <div>
          <h1>Configuration Error</h1>
          <p>The application is not properly configured. Please contact the administrator.</p>
        </div>
      </div>
    `;
    throw error;
  }
}

// Add icons to library
library.add(faFacebookF, faInstagram, faTiktok, faPhone, faEnvelope);

// Suppress ResizeObserver loop warnings
const suppressResizeObserverWarnings = () => {
  const resizeObserverError = /ResizeObserver loop completed with undelivered notifications/;
  const originalError = console.error;
  console.error = (...args) => {
    if (args.some(arg => typeof arg === 'string' && resizeObserverError.test(arg))) {
      return; // Suppress this specific error
    }
    originalError.apply(console, args);
  };

  // Also handle window error events
  window.addEventListener('error', (event) => {
    if (resizeObserverError.test(event.message)) {
      event.preventDefault();
      event.stopPropagation();
    }
  });
};

suppressResizeObserverWarnings();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
